/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoriesDto as DigiworkMaitreDPosDtoInventoryInventoriesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/Inventory/inventories-dto';

export interface GetInventories$Params {
  venueId?: string;
  isRemoved?: boolean;
}

export function getInventories(http: HttpClient, rootUrl: string, params?: GetInventories$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoriesDto>> {
  const rb = new RequestBuilder(rootUrl, getInventories.PATH, 'get');
  if (params) {
    rb.query('venueId', params.venueId, {});
    rb.query('isRemoved', params.isRemoved, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryInventoriesDto>;
    })
  );
}

getInventories.PATH = '/api/inventories';
